import React, { useMemo, useState } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { Box } from "@mui/material"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import FluxoTabs from "./componentes/fluxo-tabs"
import FormHeader from "../components/FormHeader"
import { ReactComponent as WarningIcon } from "src/v2/assets/icons/warning-error-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { 
    MOTOR_EVENTOS_PARAMETROS,
    MOTOR_EVENTOS_ORDINARIOS,
    MOTOR_EVENTOS_EXTRAORDINARIOS,
    MOTOR_EVENTOS_VALIDACAO
} from 'src/utils/routes'

export const FluxoLayout = () => {
    const location = useLocation()
    const [locationState] = useState(() => location.state || {})

    const isFluxoExistente = locationState.origem === "ver"

    const dadosCaracteristica = isFluxoExistente ? locationState.caracteristica : locationState
    const dadosParametro = isFluxoExistente ? locationState.parametro : null

    const [parametrosInfo, setParametrosInfo] = useState({
        idCaracteristica: dadosCaracteristica?.ID ?? locationState?.ID ?? null,
        cetip: dadosCaracteristica?.CETIP ?? locationState?.CETIP ?? null,
        versaoDocumento: dadosCaracteristica?.VersaoDocumento ?? locationState?.VersaoDocumento ?? null,
    })

    const [parametrosPublicadoId, setParametrosPublicadoId] = useState(dadosParametro?.ID ?? null)
    const [eventosPublicado, setEventosPublicado] = useState(false) 

    // o layout precisa saber em que página está para exibir corretamente o status do cadastro
    const isParametrosAtivo = location.pathname.includes(MOTOR_EVENTOS_PARAMETROS) ||
        (!location.pathname.includes(MOTOR_EVENTOS_ORDINARIOS) &&
            !location.pathname.includes(MOTOR_EVENTOS_EXTRAORDINARIOS) &&
            !location.pathname.includes(MOTOR_EVENTOS_VALIDACAO))

    const isProducao = isParametrosAtivo ? parametrosPublicadoId != null : eventosPublicado

    const headerConfig = useMemo(() => {
        const cetip = dadosCaracteristica?.CETIP || dadosCaracteristica?.data?.CETIP
        const versao = dadosCaracteristica?.VersaoDocumento || dadosCaracteristica?.data?.VersaoDocumento
        const tituloCetipVersao = `CETIP ${cetip} . VER ${versao || '-'}`

        if (isProducao) {
            return {
                title: tituloCetipVersao,
                statusLabel: "CADASTRO EM PRODUÇÃO",
                statusColor: "white",
                statusIcon: <CheckIcon />,
                showDownload: false
            }
        }

        return {
            title: tituloCetipVersao,
            statusLabel: "CADASTRO EM ANDAMENTO",
            statusColor: "warning",
            statusIcon: <WarningIcon />,
            showDownload: false
        }
    }, [dadosCaracteristica, isProducao,  location.pathname])

    const pageTitle = "Fluxo de Evento"

    return (
        <SideBarLayout
            title={pageTitle}
            header={true}
            headerTitle=""
            headerImage={"/background/eventos_headers.jpg"}
            headerPosition={"1% 41%"}
        >
            <Box
                sx={{
                    marginTop: -14.5,
                    paddingBottom: 5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    px: { xxxs: 3, md: 3, lg: 0 },
                }}
            >
                <Box mb={4}>
                    <FormHeader
                        title={headerConfig.title}
                        statusLabel={headerConfig.statusLabel}
                        statusColor={headerConfig.statusColor}
                        statusIcon={headerConfig.statusIcon}
                    />
                </Box>
            </Box>
            <Box sx={{ mt: -9, position: 'relative', zIndex: 2 }}>
                <FluxoTabs />
            </Box>
            <Box>
                <Outlet context={{
                    parametrosInfo,
                    setParametrosInfo,
                    parametrosPublicadoId,
                    setParametrosPublicadoId,
                    eventosPublicado,
                    setEventosPublicado,
                }} />
            </Box>
        </SideBarLayout>
    )
}

export default FluxoLayout
